import { toast } from 'react-toastify';

export default function Toast({ type, title = 'عملیات', onClose = null, autoClose = 2500 }) {

    const result = {
        err: () => toast.error(title + ` با خطا مواجه شده است `, {
            position: "top-center",
            autoClose: autoClose,
            onClose: onClose ? onClose : null,
        }),
        success: () => toast.success(title + ' با موفقیت انجام شد ', {
            position: "top-center",
            autoClose: autoClose,
            onClose: onClose ? onClose : null,
        }),
        empty: () => toast.warn(title + ' را پر کنید ', {
            position: "top-center",
            autoClose: autoClose,
            onClose: onClose ? onClose : null,
        }),
        login: () => toast.error('نام کاربری یا رمز عبور اشتباه است', {
            position: "top-center",
            autoClose: autoClose,
            onClose: onClose ? onClose : null,
        }),
        register: () => toast.error('این نام کاربری قبلا ثبت شده است', {
            position: "top-center",
            autoClose: autoClose,
            onClose: onClose ? onClose : null,
        }),
        custom: () => toast.warn(title, {
            position: "top-center",
            autoClose: autoClose,
            onClose: onClose ? onClose : null,
        }),
    }

    result[type]();
}